import {FC, useMemo} from 'react';
import style from './style.module.scss';
import {getMediaSrc} from 'core/helpers/media';
import Link from 'next/link';
import {Typography} from 'components/Typography';
import {IStock} from 'modules/stock-x/types';
import {getStockUrl} from 'modules/discount/helpers';
import {NoImage} from 'components/NoImage';

interface IProps {
    stock: IStock;
    onClick?: () => void;
}

export const StockCard: FC<IProps> = ({stock, onClick}) => {
    const {code, images, periodText, title} = stock;

    const stockUrl = useMemo(() => {
        return getStockUrl(code);
    }, [code]);

    return (
        <Link href={stockUrl} className={style.main} onClick={onClick}>
            <div className={style.imageArea} data-skeleton-item={true}>
                {images?.bannerImage ? (
                    <img
                        alt={`Акция - ${title}`}
                        className={style.image}
                        src={getMediaSrc(images.bannerImage, {
                            width: 9999,
                            isWebp: true,
                        })}
                    />
                ) : (
                    <NoImage size={'stretched'} />
                )}
            </div>
            <div className={style.contentArea}>
                <Typography
                    className={style.title}
                    variants={{
                        MB: 'ch-title-20-reg',
                        TB: 'ch-title-20-reg',
                        DT: 'ch-title-24-reg',
                    }}
                    data-skeleton-item={true}
                >
                    {title}
                </Typography>
                <Typography variants={{MB: 'label-12-m', TB: 'label-12-m', DT: 'label-14-r'}} data-skeleton-item={true}>
                    {periodText}
                </Typography>
            </div>
        </Link>
    );
};
